import * as types from '../actions/actionTypes';
import initialState from './initialState';
       
        
export default function contenidoReducer(state= initialState.contenido, action){
    let newState;
	switch(action.type){
         case types.LOAD_CONTENIDO_LIST_SUCCESS:		
            action.contenido.filtroActivo=state.filtroActivo;
            action.contenido.filtroActual=state.filtroActual;
            action.contenido.showActivos=state.showActivos;
            action.contenido.filtrosCombo=state.filtrosCombo;
			 action.contenido.paginaActual=action.contenido.pageable.pageNumber;
			 action.contenido.registrosPorPagina=action.contenido.size;
            
            return action.contenido;

        case types.BORRAR_CONTENIDO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(contenido => contenido.id !== action.contenido.id)];          
			return newState;    
            
        case types.ACTIVAR_CONTENIDO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(contenido => contenido.id !== action.contenido.id)];          
			 return newState;
            
        case types.SET_FILTRO_CONTENIDO:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
            newState.showActivos=action.filtro.showActivos;
            newState.filtrosCombo=action.filtro.filtrosCombo;
            
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}